export const blogSeedData = [];
